export default function toJS(o) {
	return JSON.parse(JSON.stringify(o));
}
